import { FunctionComponent } from "react";

import MinimalNav from "@ui/components/navigation/Navigation/components/MinimalNav";
import { RightMenuButtonsMobileProps } from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationMobile/PrimaryNavigationMobile";
import {
  PinnedNavItem,
  RightMenuButtonsDesktopProps,
} from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationStandard/PrimaryNavigationStandard";
import { NavigationVariants } from "@ui/components/navigation/Navigation/Navigation";

import PrimaryNavigationMobile from "./components/PrimaryNavigationMobile";
import PrimaryNavigationStandard from "./components/PrimaryNavigationStandard";
import * as styles from "./PrimaryNavigation.css";

interface Props {
  PrimaryLogo?: FunctionComponent<{ className?: string }>;
  Logo: FunctionComponent<{ className?: string }>;
  items: PinnedNavItem[];
  cta: {
    desktop: React.ReactElement | null;
    mobile: React.ReactElement | null;
  };
  variant: NavigationVariants;
  showLinkLines: boolean;
  showSubscribeInNav?: boolean;
  linkClassName?: string;
  rightMenuButtons: {
    desktop: React.FunctionComponent<RightMenuButtonsDesktopProps>;
    mobile: React.FunctionComponent<RightMenuButtonsMobileProps>;
  };
  tagline?: string;
}

const PrimaryNavigation: FunctionComponent<Props> = ({
  items,
  PrimaryLogo,
  Logo,
  cta,
  variant,
  showLinkLines,
  linkClassName,
  rightMenuButtons,
  showSubscribeInNav = false,
}) => {
  const monochrome = variant.startsWith("monochrome");
  return (
    <div>
      <div className={styles.breakpointFrom.navigation}>
        <PrimaryNavigationStandard
          Logo={PrimaryLogo || Logo}
          items={items}
          cta={cta.desktop}
          variant={variant === "homepage" ? "homepage" : "standard"}
          showLinkLines={showLinkLines}
          showSubscribeInNav={showSubscribeInNav}
          linkClassName={linkClassName}
          rightMenuButtons={rightMenuButtons.desktop}
          monochrome={monochrome}
        />
      </div>
      <div
        className={
          variant === "monochrome-minimal"
            ? styles.breakpointFromTabletTillNavigation
            : styles.breakpointTill.navigation
        }
      >
        <PrimaryNavigationMobile
          Logo={PrimaryLogo || Logo}
          cta={cta.mobile}
          rightMenuButtons={rightMenuButtons.mobile}
          monochrome={monochrome}
        />
      </div>
      {variant === "monochrome-minimal" && (
        <div className={styles.breakpointTill.tablet}>
          <MinimalNav Logo={Logo} />
        </div>
      )}
    </div>
  );
};

export default PrimaryNavigation;
